import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import styles from './_findYourPathLanding.css'
import Cities from 'components/util/Cities'
import screen from 'images/landing/global/find-your-path/screen.png'

function FindYourPath () {
  return (
    <div className={styles.findYourPath}>
      <Title align="center">
        <FormattedMessage id='landingPage.findYourPath.title' defaultMessage={`Find Your Path \nAnywhere`} />
      </Title>
      <Caption align="center">
        <FormattedMessage id='landingPage.findYourPath.caption' defaultMessage="Create and discover new routes wherever you are. Save your favorites for the next time you're ready to run." />
      </Caption>
      <Cities />
      <div className={styles.routes}>
        <img src={screen} />
      </div>
    </div>
  )
}

export default FindYourPath
